webpackJsonp([133186989568310],{

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecondPage = function SecondPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'Instruction' },
	      _react2.default.createElement(
	        'div',
	        { className: 'InstructionGroup' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Step 2: Acquire data for training'
	        ),
	        _react2.default.createElement(
	          'progress',
	          { value: '40', max: '100' },
	          '40 %'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* In this step, you will see a dataset containing text for training an AI-based autocomplete model. There are sentences in the dataset. Did you notice any gender bias? (Hint: look at the words after "man" and "woman")'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'https://drive.google.com/file/d/1iWIcNAM3PbmYxn-Am9sNIjQsO3oUzqHe/view?usp=sharing', title: 'Dataset', target: '_blank' },
	            'Dataset'
	          )
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* Now let\'s learn basics of the model we\'ll be using: Markov language model.'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/1-bias/' },
	          'Back'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/3-rf/' },
	          'Next step'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          'Go back to the homepage'
	        )
	      )
	    )
	  );
	};
	
	exports.default = SecondPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-2-acquire-js-e3127132b7eafae05cba.js